/**
 * FryerOilRecordType enum - synchronized with Prisma schema.
 */
export enum FryerOilRecordType {
  OIL_NOT_REPLACED = 'OIL_NOT_REPLACED',
  OIL_REPLACED = 'OIL_REPLACED',
  OIL_REGENERATED = 'OIL_REGENERATED',
}
